import Head from 'next/head';

import Post from 'src/views/Marketing/Blog/marketing/mercari-photography-tips';

export default function Example() {
  return (
    <>
      <Head>
        <title>5 Simple Yet Effective Tips To Take Good Photos for Your Mercari Listings</title>
        <meta
          name='description'
          content='Want to catch the attention of more buyers? Take clear, good photos of your items–here are the proper ways to do it.'
        />
        <link rel='canonical' href='https://tools.oneshop.com/blog/mercari-photography-tips' />
        <meta property='og:url' content='https://tools.oneshop.com/blog/mercari-photography-tips' />
        <meta property='og:title' content='5 Simple Yet Effective Tips To Take Good Photos for Your Mercari Listings' />
        <meta
          property='og:description'
          content='Want to catch the attention of more buyers? Take clear, good photos of your items–here are the proper ways to do it.'
        />
        <meta key='og-image' property='og:image' content='https://tools.oneshop.com/static/images/og-image.png?v=3' />
        <meta property='article:published_time' content='2022-09-13T00:00:00-00:00' />
        <meta property='article:modified_time' content='2022-09-13T00:00:00-00:00' />
        <meta property='article:tag' content='Mercari' />
        <meta property='article:publisher' content='https://www.facebook.com/oneshopcompany' />
      </Head>
      <Post />
    </>
  );
}
